import { createContextWithHooks } from '@/shared/utils/react';

// Lets a minimizable modal's form report its current content title (e.g. the
// email subject) upward, so the dock pill can show something meaningful. The
// value is captured (snapshotted) when the modal is minimized. Consumed
// optionally: outside a minimizable modal reporting is a no-op.
const minimizeTitleContext = createContextWithHooks<((title: string) => void) | null>(
  'MinimizeTitle',
);

export default minimizeTitleContext;
